import { render, staticRenderFns } from "./FilePlus.vue?vue&type=template&id=d28fa894&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilePlus.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FilePlus.vue
// module id = 2300
// module chunks = 1